export interface Report5SChartFilters {
  startDate: string;
  endDate: string;
  locationIds?: number[];
  departmentIds?: number[];
  areaIds: number[];
  zones?: string[];
  typeAudit?: string | null;
  auditorIds?: number[];
  coAuditorIds?: number[];
}

export interface Report5SChartMonth {
  year: number;
  monthIdx: number;
  monthName: string;
  zonePercents: Record<string, number>;
  crossPercent: number | null;
}

export interface Report5SPercentColor {
  from: number;
  to: number;
  color: string;
  label: string | null;
}

export interface Report5SChartData {
  zones: string[];
  months: Report5SChartMonth[];
  percentColors: Report5SPercentColor[];
}

export interface Report5SAuditsState {
  chart: {
    data: Report5SChartData | null;
    loading: boolean;
    error: string | null;
  };
}

export enum Report5SAuditsActionTypes {
  LOAD_CHART_REQUEST = 'report5SAudits/LOAD_CHART_REQUEST',
  LOAD_CHART_SUCCESS = 'report5SAudits/LOAD_CHART_SUCCESS',
  LOAD_CHART_FAILURE = 'report5SAudits/LOAD_CHART_FAILURE',
  CLEAR_CHART = 'report5SAudits/CLEAR_CHART',
}

export interface LoadChartRequestAction {
  type: Report5SAuditsActionTypes.LOAD_CHART_REQUEST;
  payload: { filters: Report5SChartFilters };
}

export interface LoadChartSuccessAction {
  type: Report5SAuditsActionTypes.LOAD_CHART_SUCCESS;
  payload: { data: Report5SChartData };
}

export interface LoadChartFailureAction {
  type: Report5SAuditsActionTypes.LOAD_CHART_FAILURE;
  payload: { error: string };
}

export interface ClearChartAction {
  type: Report5SAuditsActionTypes.CLEAR_CHART;
}

export type Report5SAuditsActions =
  | LoadChartRequestAction
  | LoadChartSuccessAction
  | LoadChartFailureAction
  | ClearChartAction;
